import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  padding-top: ${p => !p.noPadding && '100px'};
  background: ${p => p.background};
  max-width: 100vw;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding-top: ${p => !p.noPadding && '1rem'};
    overflow-x: hidden;
  }
`

Container.propTypes = {
  noPadding: PropTypes.boolean,
  background: PropTypes.string,
}

export default Container



// WEBPACK FOOTER //
// ./src/components/LayoutContainer/index.jsx